<template>
    <v-layout
            column
            wrap
            class="my-12"
            align-center
    >
        <v-flex xs12 sm4 class="my-4">
            <div class="text-center">
                <h2 class="headline">Regeln</h2>
                <span class="subheading">
                Wer die Regeln missachtet, <v-icon>mdi-airplane-takeoff</v-icon>
              </span>
            </div>
        </v-flex>
        <v-flex xs12>
            <v-container grid-list-xl>
                <v-layout row wrap align-center >
                    <v-flex xs12 md4 class="hidden-sm-and-down">
                    <v-card flat class="transparent" height="50vw"  min-height="300px"  max-height="400">
                        <v-card-title primary-title class="layout justify-center">
                            <div class="headline text-center">Clankrieg</div>
                        </v-card-title>
                        <v-card-text>
                            <ul>
                                <li>Nur Vize-Anführer machen die Clanburgen voll</li>
                                <li>Es wird von unten nach oben angegriffen, das bedeutet Rathaus 10er & 11er greifen so früh wie möglich an</li>
                                <li>Um den Rathaus 12ern noch genung Zeit zu geben, greifen Rathaus 10er innerhalb der ersten 12 Stunden und Rathaus 11er innerhalb der ersten 16 Stunden an</li>
                                <li>Ist es nicht möglich die oben genannten Zeiten auf Grund von Terminen einzuhalten, muss dies im Chat o.ä. kundgegeben werden</li>
                                <li>Clanspiele: 2.000 Punkte (bei mehreren Accounts, nach Absprache)</li>
                            </ul>


                        </v-card-text>
                    </v-card>
                </v-flex>
                    <v-flex xs12 md4 class="hidden-xs-only hidden-md-and-up">
                        <v-card flat class="transparent" height="50vw"  min-height="250px" max-height="250">
                            <v-card-title primary-title class="layout justify-center">
                                <div class="headline text-center">Clankrieg</div>
                            </v-card-title>
                            <v-card-text>
                                <ul>
                                    <li>Nur Vize-Anführer machen die Clanburgen voll</li>
                                    <li>Es wird von unten nach oben angegriffen, das bedeutet Rathaus 10er & 11er greifen so früh wie möglich an</li>
                                    <li>Um den Rathaus 12ern noch genung Zeit zu geben, greifen Rathaus 10er innerhalb der ersten 12 Stunden und Rathaus 11er innerhalb der ersten 16 Stunden an</li>
                                    <li>Ist es nicht möglich die oben genannten Zeiten auf Grund von Terminen einzuhalten, muss dies im Chat o.ä. kundgegeben werden</li>
                                    <li>Clanspiele: 2.000 Pumkte (bei mehreren Accounts, nach Absprache)</li>
                                </ul>


                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 md4 class="hidden-sm-and-up">
                        <v-card flat class="transparent" height="150vw"  max-height="450px">
                            <v-card-title primary-title class="layout justify-center">
                                <div class="headline text-center">Clankrieg</div>
                            </v-card-title>
                            <v-card-text>
                                <ul>
                                    <li>Nur Vize-Anführer machen die Clanburgen voll</li>
                                    <li>Es wird von unten nach oben angegriffen, das bedeutet Rathaus 10er & 11er greifen so früh wie möglich an</li>
                                    <li>Um den Rathaus 12ern noch genung Zeit zu geben, greifen Rathaus 10er innerhalb der ersten 12 Stunden und Rathaus 11er innerhalb der ersten 16 Stunden an</li>
                                    <li>Ist es nicht möglich die oben genannten Zeiten auf Grund von Terminen einzuhalten, muss dies im Chat o.ä. kundgegeben werden</li>
                                    <li>Clanspiele: 2.000 Pumkte (bei mehreren Accounts, nach Absprache</li>
                                </ul>


                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 md4 class="hidden-sm-and-down">
                        <v-card flat class="transparent" height="50vw"  min-height="300px" max-height="400">
                            <v-card-title primary-title class="layout justify-center">
                                <div class="headline">Spenden</div>
                            </v-card-title>
                            <v-card-text>
                                <ul>
                                    <li>Nur spenden was gefordert wird (wenn ihr nicht max spenden könnt vorher bescheid sagen!)</li>
                                    <li>Spendenverhältnis egal, Hauptsache viel 😊 ob viel anfragen oder viel spenden 🤷</li>
                                </ul>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 md4 class="hidden-md-and-up">
                        <v-card flat class="transparent" height="15vh"  min-height="200px">
                            <v-card-title primary-title class="layout justify-center">
                                <div class="headline">Spenden</div>
                            </v-card-title>
                            <v-card-text>
                                <ul>
                                    <li>Nur spenden was gefordert wird (wenn ihr nicht max spenden könnt vorher bescheid sagen!)</li>
                                    <li>Spendenverhältnis egal, Hauptsache viel 😊 ob viel anfragen oder viel spenden 🤷</li>
                                </ul>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 md4>
                        <v-card flat class="transparent" height="50vw"  min-height="300px" max-height="400">
                            <v-card-title primary-title class="layout justify-center">
                                <div class="headline text-center">Clankriegsliga</div>
                            </v-card-title>
                            <v-card-text>
                                <ul>
                                    <li>Hier gelten die selben Regeln wie im Clankrieg</li>
                                    <li>Gestartet wird mit den besten 15 auf grün</li>
                                    <li>WhatsApp Gruppe Pflicht</li>
                                    <li>Wer bei einem 12v11 oder 11v10 (dip) weniger als 2 Sterne 70% holt wird ausgewechselt (2 Tage 🚫Sperre🚫)</li>
                                    <li>0 Sterne (für die Aktuelle CWL 🚫Sperre🚫)</li>
                                </ul>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-flex>
    </v-layout>
</template>
<script>
    export default {
        name: 'Rules',
        data: () => ({

        }),
    };

</script>
